import React from "react";

const spinner = ({ spinnerStyle }) => {
  return (
    <div className={spinnerStyle} role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default spinner;
